import * as actionsType from "../actions/actionsType";

const analyticsReducer = (
  state = {
    // Admin analytics
    summary: null,
    timeseries: null,
    platforms: null,
    events: null,
    quality: null,
    sources: null,
    analyticsFilters: {
      period: "7d",
      from: "",
      to: "",
      granularity: "day",
      timezone: "Africa/Cairo"
    },
    analyticsLoading: false,

    // Company admin map
    mapData: null,
    branchDetail: null,
    collectionNetwork: null,
    recyclingPerformance: null,
    mapPeriod: "7d",
    mapLoading: false,
  },
  action
) => {
  switch (action.type) {
    // Admin analytics
    case actionsType.GET_ANALYTICS_SUMMARY:
      return { ...state, summary: action.payload };
    case actionsType.GET_ANALYTICS_TIMESERIES:
      return { ...state, timeseries: action.payload };
    case actionsType.GET_ANALYTICS_PLATFORMS:
      return { ...state, platforms: action.payload };
    case actionsType.GET_ANALYTICS_EVENTS:
      return { ...state, events: action.payload };
    case actionsType.GET_ANALYTICS_QUALITY:
      return { ...state, quality: action.payload };
    case actionsType.GET_ANALYTICS_SOURCES:
      return { ...state, sources: action.payload };
    case actionsType.SET_ANALYTICS_PERIOD:
      return { ...state, analyticsFilters: action.payload };
    case actionsType.SET_ANALYTICS_LOADING:
      return { ...state, analyticsLoading: action.payload };

    // Company admin map
    case actionsType.GET_MAP_DATA:
      return { ...state, mapData: action.payload };
    case actionsType.GET_MAP_BRANCH_DETAIL:
      return { ...state, branchDetail: action.payload };
    case actionsType.GET_MAP_COLLECTION_NETWORK:
      return { ...state, collectionNetwork: action.payload };
    case actionsType.GET_MAP_RECYCLING_PERFORMANCE:
      return { ...state, recyclingPerformance: action.payload };
    case actionsType.SET_MAP_LOADING:
      return { ...state, mapLoading: action.payload };
    case actionsType.SET_MAP_PERIOD:
      return { ...state, mapPeriod: action.payload };

    default:
      return state;
  }
};

export default analyticsReducer;
